/**
 * Translates the name of a story based on the provided language.
 * If the language is 'default', returns the default name of the story.
 * If a translation for the language is found, returns the translated name.
 * If no translation is found, returns 'Translation not found'.
 *
 * @param {Object} story - The story object.
 * @param {string} language - The language to translate the story name to.
 * @returns {string} The translated name of the story.
 */

// WHY NEEDED: For some reason, the language is only being passed down from components, but not pages or stories. This is a workaround.
export const translateStoryName = (story, language) => {
  if (language === 'default') {
    return story?.name;
  } else if (story.translated_slugs) {
    return (
      story?.translated_slugs.find((langObj) => langObj.lang === language)
        .name || story?.name
    );
  } else if (story.alternates) {
    return (
      story.alternates.find((alt) => alt.lang === language).name || story.name
    );
  }
};
